// extracted by mini-css-extract-plugin
module.exports = {"card":"number-card_card_1eCL-","body":"number-card_body_1yfGm","number":"number-card_number_1-AYD","imageWrapper":"number-card_imageWrapper_7YQCY"};